var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFmsPro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12036_2002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 0.5H0V48.5H48V0.5Z",
    fill: "#E31B23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2631 14.9778V10.563H4.23291V38.4371H9.16309V26.4855H13.9533V22.0022H9.16309V14.9778H14.2631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2961 10.563L23.3966 20.1374L19.5627 10.563H15.6245V38.4371H20.4504V29.4049L22.1752 35.9586H24.472L26.3011 29.1636V38.4371H31.13V10.563H27.2961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.764 18.7522V13.5449C43.764 11.7903 42.5962 10.563 40.9221 10.563H35.3425C33.7755 10.563 32.4976 11.8708 32.4976 13.4764V19.0888C32.4976 19.9586 32.8997 20.6498 33.2929 21.2575L38.7683 29.0832V34.0193H37.4277V29.3126H32.4976V35.485C32.4976 37.4004 33.9632 38.4341 35.3425 38.4341H40.9221C42.5426 38.4341 43.764 37.1532 43.764 35.4522V28.5976C43.764 27.5729 43.201 26.6881 42.7273 25.9434L37.4963 18.5675V14.9748H38.8338V18.7492H43.764V18.7522Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6211 19.7233H41.8395V20.0361H41.4284V21.3081H41.0322V20.0361H40.6211V19.7233Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7671 19.7262V21.308H43.3888L43.4126 20.182L43.4186 20.0241L43.4037 20.0807C43.3828 20.1701 43.3798 20.182 43.3649 20.2475L43.0671 21.311H42.7274L42.4415 20.2952L42.373 20.0122C42.3789 20.1373 42.3789 20.1641 42.3878 20.316L42.4087 21.314H42.0244V19.7322H42.6023L42.8436 20.6199L42.9002 20.8731C42.9241 20.7629 42.9241 20.751 42.9419 20.6795L43.1951 19.7351H43.7701L43.7671 19.7262Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12036_2002"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 48,
    height: 48,
    rx: 6,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFmsPro);
export default __webpack_public_path__ + "static/media/fms-pro.7db79ed41668ff8e9c482bf74a56ce1d.svg";
export { ForwardRef as ReactComponent };